export default "__VITE_ASSET__Dl1vda3N__"